import { Component } from 'shimmer'

import { Loader } from '@/utils/Loader'

import {
  PlaneGeometry,
  MeshPhongMaterial,
  DirectionalLight,
  AmbientLight,
  Vector3,
  TextureLoader,
  Mesh
} from 'three'

import { emitter } from '@/utils/emitter'

import { Fresnel } from '@/webGL/objects/Fresnel'
import { BlurredReflector } from '@/webGL/objects/BlurredReflector'
import { webGL } from '@/webGL/WebGL'

export class Health extends Component {
  constructor (url) {
    super('Health')
    this.promise = new Promise(resolve => {this.resolve = resolve})

    this.destroy = this.destroy.bind(this)

    this.loaderGround = Loader.load(url, false, obj => {
      obj.receiveShadow = true
      obj.castShadow = false
    }).then(obj => {
      this.obj = obj.scene
      this.add(this.obj)
    })

    this.addPlane()
    this.addLights()

    this.loaderGround.then(this.resolve)
  }

  onDestroy () {
    this.destroy()

    this.obj.traverse(child => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })

    webGL.scene.remove(this.directional)
    webGL.scenePerso.remove(this.directionalClone)
    webGL.scene.remove(this.ambient)
    webGL.scenePerso.remove(this.ambientClone)
  }

  addPlane () {
    const geo = new PlaneGeometry(400, 400, 40, 40)
    const mat = new MeshPhongMaterial({
      // color: 0xffff00,
      map: new TextureLoader().load('/images/smoke--02.png'),
      displacementMap: new TextureLoader().load('/images/smoke_displacement--02.jpg'),
      displacementScale: 50
    })
    mat.transparent = true
    const plane = new Mesh(geo, mat)
    plane.position.set(-400, 150, -300)
    
    const plane2 = plane.clone()
    plane2.position.set(300, 150, -300)
    plane2.scale.x = -1

    this.add(plane)    
    this.add(plane2)    
  }

  addLights () {
    this.directional = new DirectionalLight(0xffffff, 1)
    this.directional.position.set(-1200, 900, 1000)
    this.directional.lookAt( new Vector3(0, 0, 0) )
    webGL.scene.add(this.directional)
    this.directionalClone = this.directional.clone()
    this.directionalClone.castShadow = true
    this.directionalClone.shadow.camera.bottom = -1000
    this.directionalClone.shadow.camera.top = 1000
    this.directionalClone.shadow.camera.left = -1000
    this.directionalClone.shadow.camera.right = 1000
    this.directionalClone.shadow.camera.far = 20000
    this.directionalClone.shadow.camera.near = 100
    this.directionalClone.shadow.mapSize.width = 2048
    this.directionalClone.shadow.mapSize.height = 2048
    this.directionalClone.shadow.bias = -0.0004
    this.directionalClone.shadow.camera.updateProjectionMatrix()
    webGL.scenePerso.add(this.directionalClone)

    this.ambient = new AmbientLight(0xffffff, .3)
    this.ambientClone = this.ambient.clone()
    webGL.scene.add(this.ambient)
    webGL.scenePerso.add(this.ambientClone)
  }
}